import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async createCommissionRule(variables) {
		const res = await gql({
			query: mutation.createCommissionRule,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createCommissionRule"
		})
	},

	async addEntityToCommissionRule(variables) {
		const res = await gql({
			query: mutation.addEntityToCommissionRule,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addEntityIdToCommissionRule"
		})
	},

	async commissionRules(variables) {
		const res = await gql({
			query: query.commissionRules,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "commissionRules"
		})
	}
}
